import React from 'react';

import TableBase from 'antd/lib/table';

const Table = ({ ...props }) => <TableBase {...props} pagination={false} />;

export default Table;